"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

var withLastFlag = function withLastFlag() {
  return function (src$) {
    return (0, _rxjs.concat)(src$.pipe((0, _operators.skipLast)(1), (0, _operators.map)(function (value) {
      return [value, false];
    })), src$.pipe((0, _operators.last)(), (0, _operators.map)(function (value) {
      return [value, true];
    }), (0, _operators.catchError)(function () {})));
  };
};

var _default = withLastFlag;
exports["default"] = _default;